(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('dates', [function ajaxFactory() {
            this.convert = function (date, convertTime) {
                if (!date || !date.split) {
                    return date;
                }

                var d = date.split(/[- :TZ]/);

                if (d.length >= 5 && convertTime) {
                    return new Date(Date.UTC(d[0], d[1] - 1, d[2], d[3], d[4], d[5]));
                }
                return new Date(d[0], d[1] - 1, d[2]);
            };

            return this;
        }]);
}());
